
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    navTitle: 'Digital content',
    title: 'Important terms for receiving digital content',
    item1: 'there is no physical delivery of digital content;',
    item2: 'the service provides exclusively digital content;',
    item3: 'digital items are provided inside the platform;',
    item4: "individual items can be withdrawn by the user to their own Steam account;",
    item5: 'item transfer happens automatically;',
    item6:
      'transfer times may increase due to technical limitations of Steam or a security check.',
  },
  ru: {
    navTitle: 'Получение цифрового контента',
    title: 'Важные условия получения цифрового контента',
    item1: 'физическая доставка цифрового контента отсутствует;',
    item2: 'сервис предоставляет исключительно цифровой контент;',
    item3: 'цифровые предметы предоставляются внутри платформы;',
    item4: 'отдельные предметы могут быть выведены пользователем на собственный аккаунт Steam;',
    item5: 'передача предметов происходит автоматически;',
    item6:
      'сроки передачи могут увеличиваться из-за технических ограничений Steam либо проверки безопасности.',
  },
  uz: {
    navTitle: 'Raqamli kontent olish',
    title: 'Raqamli kontent olishning muhim shartlari',
    item1: 'raqamli kontentning jismoniy yetkazib berilishi mavjud emas;',
    item2: 'servis faqat raqamli kontent taqdim etadi;',
    item3: 'raqamli buyumlar platforma ichida taqdim etiladi;',
    item4: 'ayrim buyumlar foydalanuvchi tomonidan oʻzining Steam akkauntiga chiqarilishi mumkin;',
    item5: 'buyumlarni oʻtkazish avtomatik ravishda amalga oshiriladi;',
    item6:
      'oʻtkazish muddatlari Steam texnik cheklovlari yoki xavfsizlik tekshiruvi tufayli uzayishi mumkin.',
  },
  fa: {
    navTitle: 'محتوای دیجیتال',
    title: 'شرایط مهم دریافت محتوای دیجیتال',
    item1: 'محتوای دیجیتال تحویل فیزیکی ندارد؛',
    item2: 'سرویس فقط محتوای دیجیتال ارائه می‌دهد؛',
    item3: 'آیتم‌های دیجیتال داخل پلتفرم داده می‌شوند؛',
    item4: 'کاربر می‌تواند بعضی آیتم‌ها را به حساب استیم خودش برداشت کند؛',
    item5: 'انتقال آیتم خودکار انجام می‌شود؛',
    item6: 'محدودیت‌های فنی استیم یا بررسی امنیتی می‌تواند زمان انتقال را طولانی کند.',
  },
  pt: {
    navTitle: 'Conteúdo digital',
    title: 'Condições importantes para receber conteúdo digital',
    item1: 'não há entrega física de conteúdo digital;',
    item2: 'o serviço fornece exclusivamente conteúdo digital;',
    item3: 'os itens digitais são fornecidos dentro da plataforma;',
    item4: 'itens específicos podem ser sacados pelo usuário para a própria conta Steam;',
    item5: 'a transferência de itens acontece automaticamente;',
    item6:
      'os prazos de transferência podem aumentar por limitações técnicas da Steam ou por uma verificação de segurança.',
  },
  tr: {
    navTitle: 'Dijital içerik',
    title: 'Dijital içerik almanın önemli koşulları',
    item1: 'dijital içeriğin fiziksel teslimatı yoktur;',
    item2: 'servis yalnızca dijital içerik sunar;',
    item3: 'dijital eşyalar platform içinde sunulur;',
    item4: 'bazı eşyalar kullanıcı tarafından kendi Steam hesabına çekilebilir;',
    item5: 'eşya aktarımı otomatik gerçekleşir;',
    item6:
      "aktarım süreleri Steam'in teknik kısıtlamaları ya da güvenlik kontrolü nedeniyle uzayabilir.",
  },
  uk: {
    navTitle: 'Отримання цифрового контенту',
    title: 'Важливі умови отримання цифрового контенту',
    item1: 'фізична доставка цифрового контенту відсутня;',
    item2: 'сервіс надає виключно цифровий контент;',
    item3: 'цифрові предмети надаються всередині платформи;',
    item4: 'окремі предмети користувач може вивести на власний акаунт Steam;',
    item5: 'передача предметів відбувається автоматично;',
    item6: 'терміни передачі можуть збільшуватися через технічні обмеження Steam або перевірку безпеки.',
  },
  de: {
    navTitle: 'Erhalt digitaler Inhalte',
    title: 'Wichtige Bedingungen für den Erhalt digitaler Inhalte',
    item1: 'digitale Inhalte werden nicht physisch geliefert;',
    item2: 'der Dienst stellt ausschließlich digitale Inhalte bereit;',
    item3: 'digitale Items werden innerhalb der Plattform bereitgestellt;',
    item4: 'einzelne Items kann der Nutzer auf sein eigenes Steam-Konto auszahlen;',
    item5: 'die Übergabe der Items erfolgt automatisch;',
    item6:
      'Die Übergabezeiten können sich durch technische Einschränkungen von Steam oder eine Sicherheitsprüfung verlängern.',
  },
  es: {
    navTitle: 'Recepción de contenido digital',
    title: 'Condiciones importantes para recibir contenido digital',
    item1: 'el contenido digital no se entrega físicamente;',
    item2: 'el servicio ofrece exclusivamente contenido digital;',
    item3: 'los objetos digitales se entregan dentro de la plataforma;',
    item4: 'el usuario puede retirar algunos objetos a su propia cuenta de Steam;',
    item5: 'la transferencia de objetos se hace automáticamente;',
    item6:
      'los plazos de transferencia pueden aumentar por limitaciones técnicas de Steam o por una verificación de seguridad.',
  },
  pl: {
    navTitle: 'Odbiór treści cyfrowych',
    title: 'Ważne warunki odbioru treści cyfrowych',
    item1: 'treści cyfrowe nie są dostarczane fizycznie;',
    item2: 'serwis udostępnia wyłącznie treści cyfrowe;',
    item3: 'przedmioty cyfrowe są udostępniane wewnątrz platformy;',
    item4: 'poszczególne przedmioty użytkownik może wypłacić na własne konto Steam;',
    item5: 'przekazanie przedmiotów odbywa się automatycznie;',
    item6: 'czas przekazania może się wydłużyć z powodu ograniczeń technicznych Steam lub weryfikacji bezpieczeństwa.',
  },
});
